"use client";
import React from 'react';

interface ContentSettingsDialogProps {
  title: string;
  onClose: () => void;
  onSave: () => void;
  children: React.ReactNode;
  enableLocaleTabs?: boolean;
}

const ContentSettingsDialog: React.FC<ContentSettingsDialogProps> = ({
  title, 
  onClose, 
  onSave, 
  children
}) => {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 100 }}>
      <div style={{ background: 'white', padding: '20px', borderRadius: '5px', minWidth: '300px' }}>
        <h2>{title}</h2>
        <div>{children}</div>
        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ marginRight: '10px' }}>Cancel</button>
          <button onClick={onSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default ContentSettingsDialog;